// extracted by mini-css-extract-plugin
export default {"warningRecommended":"style_warningRecommended__WLKfV","allowedFileText":"style_allowedFileText__RgiU3","maxFileSizeText":"style_maxFileSizeText__E6z40"};